import { GQL_ID } from '@@partner:types:graphql'

import React, { useCallback, useEffect } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { useAppWebsocket } from '@@partner:helpers/hooks/useAppWebsocket'
import { useLazyFetchAssembleOrder } from '@@partner:helpers/hooks/useAssemblingOrder'
import {
  makeGraphQLErrorNotification,
  notifyError,
  notify
} from '@@partner:helpers/notification'

import { Button } from 'rsuite'

import { ROUTE_ASSEMBLING_ASSEMBLE_ORDER } from '@@partner:config/routes'
import { STATUS_PAYMENT_METHOD_ACCEPTED } from '@@partner:config/order-payment-status-codes'

import {
  BACKEND_WEBSOCKET_URI,
  WS_ROOM_PAYMENT_STATUS_NOTIFICATION,
  WS_EVENT_PAYMENT_STATUS_CHANGED
} from '@@partner:config/ws'

export interface OrderPaymentListenerProps {
  brandSlug: string
  receiverId: GQL_ID
}

export default function OrderPaymentListener ({
  brandSlug,
  receiverId
}: OrderPaymentListenerProps) {
  const { socket, ready } = useAppWebsocket(BACKEND_WEBSOCKET_URI)
  const [ , { refetch } ] = useLazyFetchAssembleOrder()

  const history = useHistory()

  const redirectToOrder = useCallback(
    (orderId: GQL_ID) => {
      const url = generatePath(ROUTE_ASSEMBLING_ASSEMBLE_ORDER, {
        brandSlug,
        orderId
      })
      history.replace(url)
    },
    [ brandSlug, history ]
  )

  useEffect(() => {
    let conn = null

    if (receiverId && ready && socket) {
      conn = socket.getSubscription(
        `${WS_ROOM_PAYMENT_STATUS_NOTIFICATION}:${receiverId}`
      )

      if (!conn) {
        conn = socket.subscribe(
          `${WS_ROOM_PAYMENT_STATUS_NOTIFICATION}:${receiverId}`
        )
      }

      conn.on(
        WS_EVENT_PAYMENT_STATUS_CHANGED,
        (message: Record<string, any>) => {
          const { order_id, status } = message

          if (status === STATUS_PAYMENT_METHOD_ACCEPTED) {
            refetch?.({ order_id }).catch(
              makeGraphQLErrorNotification('Не удалось перезагрузить заказ')
            )

            notify(
              `Поступила оплата по заказу #${order_id}!`,
              <div>
                Вы можете{' '}
                <Button
                  onClick={() => redirectToOrder(order_id)}
                  size="xs"
                  color="green"
                >
                  продолжить оформление
                </Button>
              </div>
            )
          }
        }
      )

      conn.on('error', () => {
        notifyError(
          'Проблема с сокетом',
          'Уведомление об оплате заказа может быть недоступно, пожалуйста, обновите страницу'
        )
      })
    }
  }, [ ready, receiverId, redirectToOrder, refetch, socket ])

  return <React.Fragment></React.Fragment>
}
